// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "8449") return "js/8449." + __webpack_require__.h() + ".js";
  // return url for filenames based on template
  return "js/" + chunkId + "." + __webpack_require__.h() + ".chunk.js"
}